import Interaction from "../../models/interactions/Interaction"
import Take3D from "../../models/Take3D"

function isRecord(value: unknown): value is Record<string, unknown> {
    return Boolean(value && typeof value === "object")
}

export function isValidTake3D(take3D: unknown): take3D is Take3D {
    if (!isRecord(take3D)) return false

    const hasArrayField = (key: string) =>
        !(key in take3D) || Array.isArray(take3D[key])

    return typeof take3D.id === 'string' &&
        typeof take3D.name === 'string' &&
        hasArrayField("actors") &&
        hasArrayField("interactions") &&
        hasArrayField("props") &&
        (!("mainCamera" in take3D) || isRecord(take3D.mainCamera)) &&
        (!("isExpanded" in take3D) || typeof take3D.isExpanded === 'boolean')
}

export function isValidInteraction(interaction: Interaction) {
    return interaction &&
        typeof interaction.type === "string" &&
        typeof interaction.id === "string" &&
        typeof interaction.name === "string"
}
